import { NgModule } from '@angular/core';
import { ZoomDirective } from './zoom.directive';

@NgModule({
  declarations: [ZoomDirective],
  exports: [ZoomDirective],
})
export class ZoomDirectiveModule {
}
